import { getCurrentLanguageFromUrl } from "../utils/languageUtils";

// API Endpoint configurations
export const END_POINT = {
  production: {
    BASE_URL: 'https://serverapiphu.com',
  },
  staging: {
    BASE_URL: 'https://phim3s.net',
  },
};

export const BASE_STICKER_URL = 'https://phim3s.net/uploads/stickers/';

 

// Detect environment
 const ENV_ENVIRONMENT = 'staging' as keyof typeof END_POINT;

// Dynamically include language from the URL
export const ApiConfigs = {
  baseURL:  `${END_POINT[ENV_ENVIRONMENT].BASE_URL}/${getCurrentLanguageFromUrl() || 'en'}/api/v1`,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json', // default to json, let fetch/axios set for FormData
    Accept: 'application/json',
  },
  timeout: 60000,
};

export const BASE_IMAGE_URL = END_POINT[ENV_ENVIRONMENT].BASE_URL;

export const ERROR_MESSAGES = {
  NO_INTERNET: 'No internet connection',
  REQUEST_CANCELLED: 'Request was cancelled',
  UNEXPECTED_ERROR: 'An unexpected error occurred',
};

export const REQUEST_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/auth/login/',
  REGISTER: '/auth/register',
  LOGIN_GOOGLE: '/auth/google/',
  LOGOUT: '/auth/logout',
  CSRF_TOKEN: '/auth/csrf_create/',
  
  // User Account
  USER_PROFILE: '/users/info/',
  UPDATE_PROFILE: '/users/info',
  
  // Home & Movies
  HOME: '/home/index/',
  MOVIES: '/terms/lists/',
  DETAIL: '/posts/detail/',
  LIST: '/posts/lists/',
  DETAIL_EPISODE: '/posts/chapter/',
  LIST_EPISODE: '/posts/listchapter/',
  CATEGORY: '/terms/lists/',
  
  // User Interactions
  RATING: '/posts/action/rating/',
  REPORT: '/posts/report/',
  LIKE: '/posts/action/like/',
  LIST_FAVORITE: '/users/favorites',
  LIST_JOBS: '/users/jobs',
  FAVORITE: '/posts/action/favorites/',
  SAVED: '/posts/action/save/',
  
  // Search
  SEARCH: '/posts/search/',
  SEND_LOCATION: '/users/location',
  
  // Dating
  FIND_DATING: '/finder/finds/',
  NEAR_YOU: '/finder/nearyou/',
  LIKE_DATING: '/finder/likeyou/',
  DATING_HOME: '/finder/',
  DETAIL_USER: '/finder/detail/',
  
  // Chat
  CHAT: '/chat/index/',
  CHAT_DETAIL: '/chat/detail/',
  GAME_TRENDING: '/posts/lists/game/',
  SEARCH_MESSAGE: '/chat/search/',
  GET_IMAGE_CHAT: '/uploads/chats',
  LIST_STICKER: '/sticker/index',
  
  // FCM & Saved Posts
  SEND_FCM_TOKEN: '/users/fcmtoken',
  GET_SAVE_POST: '/posts/action/save/',
  SAVE_POST: '/posts/action/save/',
  LIST_USER_PREMIUM: '/finder/package/gold/',
};

// Key Query for React Query
export const KeyQueryApi = {
  DASHBOARD_HOME: 'dashboardHome',
  DASHBOARD:"dashboard",
  DASHBOARD_MOVIES: 'dashboardMovies',
  DASHBOARD_COMIC: 'dashboardComic',
  DASHBOARD_GAME: 'dashboardGame',
  DASHBOARD_DATING: 'dashboardDating',
  DASHBOARD_SEARCH: 'dashboardSearch',
  POST_DETAIL: 'postDetail',
  GET_LIST_POST: 'getListPost',
  FIND_LIST_USER: 'findListUser',
  GET_LIST_EPISODE: 'getListEpisode',
  GET_DETAIL_EPISODE: 'getDetailEpisode',
  GET_SAVED_POST: 'getSavedPost',
  GET_CATEGORIES: 'getCategories',
  GET_LIST_STICKER: 'getListSticker',
 };
